<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'card3',
})
</script>
<template>
    <div v-if="data" :id="'card'+data.id">
      <contenttitle :data="data"></contenttitle>
      <div class="float-container margin-tb-lg ">
        <div
        :style="{height:getHeight(i)}"
        :class="getClass(i)"
        v-for="(item,i) in data.child"  :key="i">
          <div class="content-box bg-img text-white" :style="{backgroundImage:'url('+addip(item.pic)+')'}">
            <a :href="item.url" class=" flex-column"   >
                        <h2>{{ item.name }}</h2>
                        <h4 v-if="item.sub"> {{ item.sub }}</h4>
                        <ArrowRightOutlined />
                      </a>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
</template>
<script setup lang="ts" name="card3">
import {defineComponent,defineProps ,onMounted,ref} from 'vue';
import {addip,colors,getCol} from '@/utils/util'
import {ArrowRightOutlined, PropertySafetyFilled}  from '@ant-design/icons-vue'
const props=defineProps({
  data:Object
})
const width=ref<Number>(128)
const screenwidth=ref<Number>(window.innerWidth)
onMounted(()=>{
  var fl= document.querySelector('#card'+props.data.id+' .float-box')
  width.value= fl.offsetWidth
})
const getClass=(i)=>{
  let v='float-box'
  v+=((Math.round(i/4)%2)==1?' float-box-right':'')
  return v
}
const getHeight=(i)=>{
  if(i%4==0){
    return width.value+'px'
  }else if(screenwidth.value<768){
    return 'auto'
  }else{
    return  width.value/3+'px'
  }
}
</script>
<style lang="less">
.card3 .content-box{
  padding:30px;
  .anticon{position: absolute;right:30px;bottom:30px;transition: all linear .2s;opacity:0.1;font-size: 5em;}
}
.card3 .content-box:hover{
  background-origin:60%;
  -webkit-backdrop-filter:blur(10px);
  backdrop-filter: blur(10px); /* 调整数值控制模糊程度 */
    .anticon {
      opacity: 1;transform: translateX(10px);
    }
  }
</style>
